import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ListaCorResponse } from '../../responses/repositorio-tintas/lista-cor.response';

@Injectable({
  providedIn: 'root',
})
export class CorService extends CommonService {
  constructor(private httpClient: HttpClient) {
    super();
  }

  public listaCor(idFabricante: number, paginaAtual: number): Observable<ListaCorResponse> {
    const uri: string = `cor/listaCor/idFabricante/${idFabricante}?paginaAtual=${paginaAtual}`;

    return this.httpClient
      .get<ListaCorResponse>(environment.urlApiRepositorioTintas + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
